import type { ListItem } from "../../components/List/List"
import { MemoryClass } from "./MemoryClass"
import { convertToLocalMoney } from "../Generics/Helps"
import { EEnableStatusType } from "../../Enum/EEnableStatusType"
import { AddtionalEntity } from "../Addtional/AddtionalEntity"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCirclePlus, faTag } from "@fortawesome/free-solid-svg-icons"

export class AddtionalMemory extends MemoryClass<AddtionalEntity> {
  setList = (addtionals: AddtionalEntity[]) => {
    this.listData = addtionals
  }

  protected cloneEntity(item: AddtionalEntity): AddtionalEntity {
    return new AddtionalEntity({ ...item })
  }

  getListCards = (all: boolean): ListItem[] => {
    const cards: ListItem[] = []

    let count = 0

    this.listData.forEach((ss) => {
      if (all || ss.status === EEnableStatusType.Active) {
        cards.push(this.getCard(ss, count))
      }

      count++
    })

    return cards
  }

  protected getItemId(item: AddtionalEntity): number {
    return item.id
  }

  getCard(ss: AddtionalEntity, count: number): ListItem {
    const enable = ss.status === EEnableStatusType.Active

    const hasImage = (ss.iconUrl ?? "").trim().length > 0
    const hasDescription = (ss.description ?? "").trim().length > 0

    return {
      isDisable: !enable,
      id: ss.id,
      title: ss.name,
      linkImage: ss.iconUrl,
      index: count,
      dataFilter: [ss.name, ss.status.toEnableStatusTypeString(), hasImage ? "com imagem" : "sem imagem"],
      children: (
        <div
          className={`
          flex flex-col gap-3
          p-4
          rounded-2xl
          transition-all duration-300
          ${enable ? "bg-gradient-to-r from-orange-50 to-white hover:shadow-lg hover:scale-[1.01]" : "bg-gray-100 opacity-70"}
        `}
        >
          <div className="flex items-start justify-between gap-4">
            <div className="flex gap-3 min-w-0 flex-1">
              {!hasImage && (
                <div className="w-11 h-11 rounded-xl bg-orange-200 text-orange-700 flex items-center justify-center shrink-0">
                  <FontAwesomeIcon icon={faCirclePlus} />
                </div>
              )}

              <div className="flex flex-col min-w-0">
                <span className="text-base font-extrabold text-gray-900 truncate">{ss.name}</span>
                <p className="text-sm text-gray-700 line-clamp-2 font-medium">{ss.description || "Sem descrição"}</p>
              </div>
            </div>

            <span
              className={`px-3 py-1 text-xs font-bold rounded-full whitespace-nowrap ${
                enable ? "bg-green-100 text-green-700" : "bg-red-100 text-red-600"
              }`}
            >
              {enable ? "Ativo" : "Inativo"}
            </span>
          </div>

          <div className="border-t border-gray-200 pt-3 flex items-center justify-between">
            <span className="text-2xl font-extrabold text-orange-700 whitespace-nowrap">
              {convertToLocalMoney(parseFloat(ss.value))}
            </span>

            <div className="flex flex-wrap gap-2 justify-end">
              <span className="px-2 py-1 text-xs rounded-full bg-amber-100 text-amber-700 font-semibold flex items-center gap-1">
                <FontAwesomeIcon icon={faTag} className="text-[10px]" />
                Adicional
              </span>

              {hasImage && <span className="px-2 py-1 text-xs rounded-full bg-cyan-100 text-cyan-700 font-medium">🖼️ Imagem</span>}

              {!hasDescription && (
                <span className="px-2 py-1 text-xs rounded-full bg-gray-100 text-gray-600 font-medium">Sem descrição</span>
              )}
            </div>
          </div>
        </div>
      ),
    }
  }
}
